import type { Scene, SceneCategory } from '@lumen5/luminary';

export const DEFAULT_COPY_STICKERS = true;

export class BaseSceneSwapBridge {
    _from: SceneCategory | undefined;
    _to: SceneCategory | undefined;
    _swapWillAlterSceneGroup = false;
    _copyStickers = DEFAULT_COPY_STICKERS;

    _isSwapAllowedFor(originalScene: Scene): boolean {
        throw Error('should be implemented by child class');
    }

    doPreSwapTransformation(originalScene: Scene, targetScene: Scene): void {
        // child classes can optionally override this
    }

    doPostSwapTransformation(originalScene: Scene, targetScene: Scene): void {
        // child classes can optionally override this
    }

    isSwapAllowed(originalScene: Scene, targetSceneCategory: SceneCategory): boolean {
        return (
            this._from === originalScene.sceneCategory &&
            this._to === targetSceneCategory &&
            this._isSwapAllowedFor(originalScene)
        );
    }

    get swapWillAlterSceneGroup(): boolean {
        return this._swapWillAlterSceneGroup;
    }
}
